import { motion } from "framer-motion";
import { PlayCircle, Sparkles } from "lucide-react";

export const TalentCardView = ({ card, index = 0, testId = "talent-card" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay: Math.min(index * 0.1, 0.5), ease: [0.16, 1, 0.3, 1] }}
    className="glass-card overflow-hidden"
    data-testid={testId}
  >
    <div className="stage-keyline" />
    <div className="p-8 sm:p-10">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.4em] text-[#FF4D00] mb-6">
        <Sparkles className="w-3.5 h-3.5" /> The Splash Team
      </div>

      <h1 className="font-bebas text-6xl sm:text-7xl uppercase leading-[0.88] tracking-[0.06em] text-white" data-testid="talent-name">
        {card.name}
      </h1>
      <div className="name-rule mt-5 mb-8" />

      {card.expertise?.length > 0 && (
        <div className="flex flex-wrap gap-2.5 mb-10" data-testid="talent-expertise">
          {card.expertise.map((x) => (
            <span key={x} className="glass-pill text-[11px] uppercase tracking-[0.18em] text-[#FF6A2B] px-3.5 py-2 rounded-sm">
              {x}
            </span>
          ))}
        </div>
      )}

      {card.highlights?.length > 0 && (
        <div className="mb-10" data-testid="talent-highlights">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#A1A1AA] mb-6">Professional Summary</div>
          <ul className="space-y-5">
            {card.highlights.map((h, i) => (
              <li key={i} className="flex items-start gap-5">
                <span className="font-bebas text-4xl text-[#FF4D00] leading-none w-10 shrink-0 drop-shadow-[0_0_10px_rgba(255,77,0,0.5)]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-base text-[#E4E4E7] leading-relaxed pt-1.5">{h}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {card.reel_url && (
        <a
          data-testid="talent-reel-link"
          href={card.reel_url}
          target="_blank"
          rel="noreferrer"
          className="glow-cta inline-flex items-center gap-3 bg-[#FF4D00] text-white px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium hover:bg-[#E64500] rounded-sm"
        >
          <PlayCircle className="w-5 h-5" /> Watch the reel
        </a>
      )}
    </div>
  </motion.div>
);
